<template>
  <v-menu
    ref="menu"
    v-model="isDatePickerOpen"
    :close-on-content-click="false"
    transition="scroll-y-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-bind="$attrs"
        :value="displayDate"
        clearable
        readonly
        append-icon="mdi-calendar"
        v-on="on"
        hide-details="auto"
        @click:clear="clearDate"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="dateValue"
      color="#0D47A1"
      locale="vi-VN"
      scrollable
      :allowed-dates="allowedDates"
      @click:date="handleDateSelect"
    >
      <v-btn outlined @click="cancel">Hủy</v-btn>
      <v-spacer></v-spacer>
      <v-btn dark depressed color="#0D47A1" @click="onDateChange">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    date: String,
    minDate: {
      type: String,
      default: ''
    },
    maxDate: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    isDatePickerOpen: false,
    dateValue: '',
    initialDate: '' // Biến lưu date hiện tại khi mở datepicker
  }),
  computed: {
    displayDate() {
      const date = moment(this.dateValue)
      if (date.isValid()) {
        return date.format('DD/MM/YYYY')
      } else {
        return ''
      }
    }
  },
  created() {
    this.dateValue = this.date
  },
  watch: {
    date() {
      this.dateValue = this.date
    },
    isDatePickerOpen(newVal) {
      if (newVal === true) {
        this.initialDate = this.dateValue
      }
    }
  },
  methods: {
    cancel() {
      // Reset lại về date ban đầu nếu ấn hủy chọn date
      this.dateValue = this.initialDate
      this.$emit('update:date', this.dateValue)
      this.isDatePickerOpen = false
    },
    handleDateSelect(dateSelected) {
      this.$emit('update:date', dateSelected)
    },
    onDateChange() {
      this.$emit('update:date', this.dateValue)
      this.isDatePickerOpen = false
    },
    validDate() {},
    clearDate() {
      this.dateValue = ''
      this.$emit('update:date', this.dateValue)
    },
    allowedDates(val) {
      const min = moment(this.minDate)
      const max = moment(this.maxDate)
      const date = moment(val)
      let flag = true

      if (min.isValid()) {
        if (date.isSameOrAfter(min)) {
          flag = true
        } else {
          flag = false
        }
      }
      if (max.isValid()) {
        if (date.isSameOrBefore(max)) {
          flag = true
        } else {
          flag = false
        }
      }
      return flag
    }
  }
}
</script>

<style scoped></style>
